import { useCallback, useEffect, useState } from "react"

const STORAGE_KEY = "sidebar:collapsed"
const MOBILE_BREAKPOINT_PX = 768
const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX}px)`

const readPersistedCollapsed = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return raw === null ? null : JSON.parse(raw)
  } catch {
    return null
  }
}

const persistCollapsed = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // ignore quota / privacy mode errors
  }
}

const matchesMobileViewport = () => {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
}

const resolveInitialCollapsed = () => {
  if (matchesMobileViewport()) return true
  const persisted = readPersistedCollapsed()
  return typeof persisted === "boolean" ? persisted : false
}

export const useSidebarCollapse = () => {
  const [collapsed, setCollapsed] = useState(resolveInitialCollapsed)
  const [isMobile, setIsMobile] = useState(matchesMobileViewport)

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY)
    const handleViewportChange = (event) => {
      setIsMobile(event.matches)
      if (event.matches) setCollapsed(true)
    }

    mediaQuery.addEventListener("change", handleViewportChange)
    return () => mediaQuery.removeEventListener("change", handleViewportChange)
  }, [])

  useEffect(() => {
    if (!isMobile) persistCollapsed(collapsed)
  }, [collapsed, isMobile])

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [])

  return { collapsed, isMobile, toggle, setCollapsed }
}
